import classNames from 'classnames';
import { Column, IColumnProps } from 'domains/designers/TruthTable/columns/Column';

export function AddPhraseColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-add-condition', className)} {...otherProps} />;
}

export function EvaluationColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-evaluation', className)} {...otherProps} />;
}

export function OutputColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-output', className)} {...otherProps} />;
}

export function PhraseColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-phrase', className)} {...otherProps} />;
}

export function SettingsColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-settings', className)} {...otherProps} />;
}

export function ActionsColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-actions', className)} {...otherProps} />;
}

export function HeaderActionsColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-header-actions', className)} {...otherProps} />;
}

export function OrderNumberColumn({ className, ...otherProps }: IColumnProps) {
  return <Column className={classNames('tt-table__col-order-number', className)} {...otherProps} />;
}
